{
  "#PMS_ARBEITSBERICHT_STATISTIK": {
    "PAGES": {
      "QUERY":{
        "SUBMIT": "Abfragen"
      },
      "RESULT": {
        "TITLE": "Ergebnis"
      }
    },
    "DIALOGS": {
      "EDIT_DATE": {
        "TITLE": "Datum ändern",
        "CANCEL": "Abbrechen",
        "SAVE": "Speichern"
      },
      "EDIT_FOK": {
        "TITLE": "Field-Ok ändern",
        "CANCEL": "Abbrechen",
        "SAVE": "Speichern"
      },
      "EDIT_SELECT": {
        "TITLE": "Ebene ändern",
        "CANCEL": "Abbrechen",
        "SAVE": "Speichern"
      }
    },
    "TITLE": "Arbeitsberichtsstatistik",
    "HEADER_TITLE": "Ebene",
    "LABEL_EBENE": "Ebene",
    "LABEL_ID": "ID",
    "LABEL_GROUP": "Gruppe",
    "LABEL_VON_DATUM": "Von Datum",
    "LABEL_BIS_DATUM": "Bis Datum",
    "LABEL_MITARBEITER": "Mitarbeiter",
    "LABEL_PERSONALNUMMER": "Personalnummer",
    "LABEL_BESCHREIBUNG": "Beschreibung",
    "LABEL_ARBEITSZEIT": "Arbeitszeit",
    "LABEL_VERRZEIT": "Verr. Zeit",
    "LABEL_DATUM": "Datum",
    "LABEL_OBJEKT": "Objekt",
    "LABEL_OBJEKTGRUPPE": "Objektgruppe",
    "LABEL_KUNDE": "Kunde",
    "LABEL_KUNDENGRUPPE": "Kundengruppe",
    "LABEL_ABTEILUNG": "Abteilung",
    "LABEL_KOSTENSTELLE": "Kostenstelle",
    "LABEL_LEITER": "Leiter",
    "LABEL_STUNDEN": "Stunden",
    "LABEL_KZVERRZEIT": "KZVERRZEIT",
    "LABEL_TSUM_STUNDEN": "TSUM Stunden",
    "LABEL_TVR_SUM": "TVR SUM",
    "LABEL_BEMERKUNG": "Bemerkung",
    "LABEL_TICKET": "Ticket",
    "LABEL_TICKET_TYP": "Ticket Typ",
    "LABEL_COBIT": "Cobit-Kategorie",
    "LABEL_IS_CVS": "CVS",
    "LABEL_IS_COPIED": "Kopiert",
    "LABEL_PLANZEIT": "Planzeit",
    "LABEL_DIFFZEIT": "Diff. Zeit",
    "LABEL_DP": "Am Dienstplan",
    "LABEL_TICKETS": "Tickets",
    "LABEL_GESAMT": "Gesamt",
    "LABEL_PRODUKTIV": "Davon produktiv",
    "LABEL_AUFTRAG": "Auftrag",
    "LABEL_REGIE": "Regie",
    "LABEL_LIEFERSCHEIN": "Lieferschein",
    "LABEL_WARTUNG": "Wartung",
    "LABEL_KEINE": "Keine",
    "LABEL_ENTWICKLUNG": "Entwicklung",
    "LABEL_INTERN": "Intern",
    "LABEL_VERRZEIT_RA": "Abgerechnet",
    "LABEL_VERRZEIT_RNA": "Nicht abgerechnet",
    "LABEL_GESCHLOSSEN": "Geschlossen",
    "LABEL_OFFEN": "Offen",
    "LABEL_TICKETS_GESCHLOSSEN": "Tickets Geschlossen",
    "LABEL_TICKETS_OFFEN": "Tickets Offen",
    "LABEL_TICKETS_GESCHLOSSEN_PLANZEIT": "Planzeit überschritten (geschlossen)",
    "LABEL_TICKETS_OFFEN_PLANZEIT": "Planzeit überschritten (offen)",
    "EBENE": {
      "FIRMA": "Firma",
      "ABTEILUNG": "Abteilungen",
      "MITARBEITER": "Mitarbeiter",
      "OBJEKT": "Objekte",
      "KOSTENSTELLE": "Kostenstellen",
      "KUNDE": "Kunden",
      "KUNDENGRUPPE": "Kundengruppen",
      "OBJEKTGRUPPE": "Objektgruppen",
      "LEITER": "Leiter",
      "EINZELN": "Einzelne"
    },
    "NO_DATA": "Keine Daten zum Anzeigen vorhanden"
  }
}
